import { FC, memo } from 'react';
import { Button, Tooltip } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import SiteMenu from '../SiteMenu/SiteMenu';
import Blocks from '../Blocks/Blocks';
import { IncomingStatistics } from './IncomingStatistics/IncomingStatistics';
import { useIncomingStatistics } from '../../hooks/components/useIncomingStatistics/useIncomingStatistics';
import { IncomingStatisticsFilter } from './IncomingStatistics/IncomingStatisticsFilter/IncomingStatisticsFilter';
import blockStyles from '../Blocks/style.module.css';
import { useStatisticsExport } from '../StatisticsV2/shared/useStatisticsExport';
import { TaskCampaignFilter } from '../shared/TaskCampaignFilter';
import filterStyles from './IncomingStatistics/IncomingStatisticsFilter/style.module.css';

interface Props {
  selectedKey: string;
  onUpdateData: (key: string) => void;
  showIncoming: boolean;
}

export const IncomingStatisticsV2: FC<Props> = memo(
  ({ selectedKey, onUpdateData, showIncoming }: Props) => {
    const propsIncomingStatistics = useIncomingStatistics();
    const report = useStatisticsExport({
      direction: 'inbound',
      sections: propsIncomingStatistics.dataSource,
      request: propsIncomingStatistics.statisticsRequest,
      ready: propsIncomingStatistics.canExportStatistics,
    });
    return (
      <>
        <Blocks
          topBlock={
            <div className={blockStyles.topBlockRow}>
              <SiteMenu
                title="Статистика входящих заданий"
                svg={true}
                svgType="incomingStats"
              />
              <Tooltip title="Сформировать отчет">
                <Button
                  type="primary"
                  aria-label="Сформировать отчет"
                  icon={<FileTextOutlined />}
                  loading={report.isReportLoading}
                  disabled={!report.canExport}
                  onClick={report.handleReport}
                />
              </Tooltip>
            </div>
          }
          middleBlock={
            <IncomingStatisticsFilter
              clinics={propsIncomingStatistics.clinics}
              onClinicsChange={propsIncomingStatistics.onClinicsChange}
              onRangePickerChange={propsIncomingStatistics.handleRangePicker}
              dateRange={propsIncomingStatistics.dateRange}
              clinicValue={propsIncomingStatistics.selectedClinics}
              filterOption={propsIncomingStatistics.filterOption}
              onOpenClinics={propsIncomingStatistics.handleOpenClinics}
              scenarioValue={propsIncomingStatistics.selectedScenario}
              scenarioOptions={propsIncomingStatistics.scenarioOptions}
              onScenarioChange={propsIncomingStatistics.handleScenarioChange}
              showTemplateFilter={propsIncomingStatistics.showTemplateFilter}
              campaignFilter={
                <TaskCampaignFilter
                  classNames={{
                    container: filterStyles.inputsContainer,
                    input: filterStyles.input,
                  }}
                  types={propsIncomingStatistics.statisticsRequest.Types ?? []}
                  value={propsIncomingStatistics.campaignFilters}
                  onChange={propsIncomingStatistics.onCampaignFiltersChange}
                />
              }
            />
          }
          mainBlock={
            <IncomingStatistics
              key="incoming"
              dataSource={propsIncomingStatistics.dataSource}
              loading={propsIncomingStatistics.isLoading}
              sectionModes={report.sectionModes}
              onSectionModeChange={report.handleSectionModeChange}
            />
          }
        />
      </>
    );
  },
);

IncomingStatisticsV2.displayName = 'IncomingStatisticsV2';
